import {Component, input, InputSignal} from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-header-card',
  imports: [
    SkeletonModule
  ],
  templateUrl: './header-card.html',
  styleUrl: './header-card.css'
})
export class HeaderCard {

  public loading: InputSignal<boolean> = input<boolean>(false);

  public icon: InputSignal<string|null> = input<string|null>(null);
  public content: InputSignal<string|null> = input<string|null>(null);
  public descriptionLight: InputSignal<string|null> = input<string|null>(null);
  public descriptionDark: InputSignal<string|null> = input<string|null>(null);
  public footerLight: InputSignal<string|null> = input<string|null>(null);
  public footerDark: InputSignal<string|null> = input<string|null>(null);

}
